import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PageInputComponent } from "../../models/page-input/page-input.component";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SiteproviderService } from '../../../services/siteprovider.service';
import { EmailData } from '../../../interfaces/interfaces';
import { NgRecaptcha3Service } from 'ng-recaptcha3'
import { SubmissionComponent } from '../submission/submission.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-contact',
  imports: [
    ReactiveFormsModule, 
    PageInputComponent,
    SubmissionComponent
  ],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
})

export class ContactComponent implements OnInit {

  // Form Variables
  contactForm!: FormGroup;
  service!: SiteproviderService;
  isSubmitted = false;
  isSubmitError = false;

  constructor(private _builder: FormBuilder, _sps: SiteproviderService, private recaptchaV3Service: NgRecaptcha3Service) {

    // Form Controls
    this.contactForm = this._builder.group({
      name: ['', { validators: [Validators.minLength(3), Validators.required] }],
      email: ['', { validators: [Validators.email, Validators.required] }],
      comments: ['', { validators: [Validators.required] }]
    })

    // Service
    this.service = _sps;
  }

  ngOnInit(): void {
    this.recaptchaV3Service.init(environment.siteKey).then(status => {
      // status: success/error
      // success - script is loaded and greaptcha is ready
      // error - script is not loaded
      //console.log(status)
    })
  }

  public ngOnDestroy() {
    this.recaptchaV3Service.destroy();
  }

  onSubmit(form: FormGroup) {
    const isFormValid = this.contactForm.valid;
    this.isSubmitted = true;

    if(!isFormValid) {
      this.isSubmitted = false;
      return;
    }

    // generate new token
    this.recaptchaV3Service.getToken().then(token => 
      {
        const formData = this.contactForm.value;
        formData.recaptchaToken = token;
        
        // Build JSON to send to API Gateway
        let body: EmailData = {
          name: form.value.name,
          email: form.value.email,
          comments: form.value.comments
        };

        this.service.postContactEmail(body).subscribe({
          next: (res) => {
            this.isSubmitted = false;
            this.isSubmitError = false;
            this.service.onSuccess('Successfully Submitted');
            form.reset();
          },
          error: (error) => {
            this.isSubmitError = true;
            this.isSubmitted = false;
            this.service.onError('Error Sending Message');
            this.service.handleError(error);
            form.reset();
          }
        });

      }, 
      error => {
        // get error, e.g. if key is invalid
        this.service.onError('Recaptcha Key Invalid: ' + error);
      }
    );
  }
}
